import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router'
import Navbar from '@/components/navbar'
import Footer from '@/components/footer'
import { useIsMobile } from '@/hooks/useIsMobile'

export const Route = createFileRoute('/_layout')({
  component: LayoutComponent,
})

function LayoutComponent() {
  const isMobile = useIsMobile()
  const detailMatch = useMatch({
    from: '/_layout/ubytovani/$slug/$unitSlug/',
    shouldThrow: false,
  })
  const reservationMatch = useMatch({
    from: '/_layout/ubytovani/$slug/$unitSlug/rezervace',
    shouldThrow: false,
  })
  const orderMatch = useMatch({
    from: '/_layout/objednavka/$orderNumber',
    shouldThrow: false,
  })
  const hideTopNavigation = isMobile && (detailMatch || reservationMatch)

  const hideBottomNavigation = isMobile && (detailMatch || reservationMatch || orderMatch)

  return (
    <div className="flex min-h-screen flex-col">
      {!hideTopNavigation && <Navbar isLight={false} />}
      <main className="flex-1">
        <Outlet />
      </main>
      {!hideBottomNavigation && <Footer />}
    </div>
  )
}
